module.exports = __webpack_public_path__ + "img/task-active.6c0780fb.svg";